import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DesmarcarOutrasOpcoesService {
  strNenhumOpcao: String = 'Nenhuma das opções anteriores';

  constructor() { }

  desmarcarOutrasOpcoes(lista, item) {
    if (item.descricao === this.strNenhumOpcao) {
      lista.filter(lc => lc.descricao !== this.strNenhumOpcao).map(lc => lc.selecionado = false);
    } else {
      lista.filter(lc => lc.descricao === this.strNenhumOpcao).map(lc => lc.selecionado = false);
    }
  }

  desmarcarTodasOpcoes(lista){
    lista.map(lc => lc.selecionado = false);
  }

  desmarcarTodasOpcoesExcetoItem(lista, item){
    lista.filter(lc => lc.id !== item.id).map(lc => lc.selecionado = false);
  }
}
